import React, { ReactNode } from 'react';
import { getDMLevelDetailPath } from 'routing/paths';
// components
import Link from '@material-ui/core/Link';
import { CustomLink } from 'components/Links';

interface Props {
  zoneId: number;
  levelId: number;
  children: ReactNode;
  withReturnUrl?: boolean;
}

export const LevelLink = (props: Props): JSX.Element => {
  const { zoneId, levelId, withReturnUrl, children } = props;

  return (
    <Link
      component={ CustomLink }
      color="secondary"
      to={ getDMLevelDetailPath(zoneId, levelId) }
      withReturnUrl={ withReturnUrl }
    >
      { children }
    </Link>
  );
};
